const list = [
  {
    id: 1,
    title: "Croma 80 cm (32 Inches) HD Ready LED TV (CREL7369, Black) (2021 Model)",
    price: 8190,
    img: "https://m.media-amazon.com/images/W/WEBP_402378-T1/images/I/718y1yr8SNL._SY355_.jpg",
    amount: 1,
  },
  {
    id: 2,
    title: "Redmi 126 cm (50 inches) 4K Ultra HD Android Smart LED TV X50 | L50M6-RA (Black)",
    price: 32999,
    img: "https://m.media-amazon.com/images/W/WEBP_402378-T1/images/I/41Om+JyC4iL._SX300_SY300_.jpg",
    amount: 1,
  },
  {
    id: 3,
    title: "Mi 11X 5G (Cosmic Black 6GB RAM 128GB ROM) | SD 870 | DisplayMate A+ rated E4 AMOLED | Upto 18 Months No Cost EMI | Extra offers on Exchange",
    
    price: 27999,
    img: "https://m.media-amazon.com/images/W/WEBP_402378-T1/images/I/71VQXjN6R7S._SX679_.jpg",
    amount: 1,
  },
  {
    id: 4,
    title: "Mi 10i 5G (Atlantic Blue, 6GB RAM, 128GB Storage) - 108MP Quad Camera | Snapdragon 750G Processor",
    price: 23988,
    img: "https://m.media-amazon.com/images/W/WEBP_402378-T1/images/I/71w4n2itCNL._SY606_.jpg",
    amount: 1,
  },
  {
    id: 5,
    title: "MI REDMI 9i Sport (Carbon Black, 64 GB) (4 GB RAM)",
    price: 8990,
    img: "https://m.media-amazon.com/images/W/WEBP_402378-T1/images/I/31Hb9RGI+jL._SY300_SX300_.jpg",
    amount: 1,
  },
  {
    id: 6,
    title: "Xiaomi Mi Smart Band 6 - 1.56''",
    price: 3499,
    img: "https://m.media-amazon.com/images/W/WEBP_402378-T1/images/I/61Tc7hKz-lS._SY450_.jpg",
    amount: 1,
  },
  {
    id: 7,
    title: "Mi 11X Pro 5G (Lunar White, 8GB RAM, 128GB Storage) | Snapdragon 888 | 108MP Camera | Extra Offers on Exchange",
    price: 36999,
    img: "https://m.media-amazon.com/images/W/WEBP_402378-T1/images/I/71+g+SNcILS._SY606_.jpg",
    amount: 1,
  },
  {
    id: 8,
    title: "Mi Redmi 8 Smartphone (Onyx Black, 4GB RAM, 64GB Storage)",
    price: 11218,
    img: "https://m.media-amazon.com/images/W/WEBP_402378-T1/images/I/71Yxd73ba9L._SY606_.jpg",
    amount: 1,
  },
  {
    id: 9,
    title: "Mi 11X 5G (Celestial Silver 6GB RAM 128GB ROM) ",
    price: 27999,
    img: "https://m.media-amazon.com/images/W/WEBP_402378-T1/images/I/81PQCRubagS._SX679_.jpg",
    amount: 1,
  },
  {
    id: 10,
    title: "(Renewed) Mi A2 (Black, 4GB RAM, 64GB Storage)",
    price: 8878,
    img: "https://m.media-amazon.com/images/W/WEBP_402378-T1/images/I/91v4EIl4uiL._SY606_.jpg",
    amount: 1,
  },
  {
    id: 11,
    title: "Mi Redmi -Note 7S (Sapphire Blue, 64GB, 4GB RAM)",
    price: 12990,
    img: "https://images-eu.ssl-images-amazon.com/images/W/WEBP_402378-T1/images/I/51I6YHC5q5L._SX300_SY300_QL70_FMwebp_.jpg",
    amount: 1,
  },
  {
    id: 12,
    title: "MI Poco M2 Pro (Out of The Blue, 4GB RAM, 64GB Storage)",
    price: 12990,
    img: "https://m.media-amazon.com/images/W/WEBP_402378-T1/images/I/81zX4xnnfgL._SY606_.jpg",
    amount: 1,
  },
];

export default list;
